import { render, staticRenderFns } from "./tableColumns.vue?vue&type=template&id=e8b1627e&scoped=true&"
import script from "./tableColumns.vue?vue&type=script&lang=js&"
export * from "./tableColumns.vue?vue&type=script&lang=js&"
import style0 from "./tableColumns.vue?vue&type=style&index=0&id=e8b1627e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b1627e",
  null
  
)

component.options.__file = "tableColumns.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VCheckbox,
  VDivider,
  VIcon,
  VList,
  VListTile,
  VMenu,
  VSpacer,
})
